import { Navigate } from 'react-router-dom';
import {
  RootLayout,
  DetailLayout,
  HomePage,
  NotFound,
  AccessGroupLayout,
  AccessGroupList,
  AccessGroupAdd,
  AccessGroupAttachAccess,
  AccessGroupGeneralInfo,
  AccessGroupAccess,
  AccessGroupAccessEdit,
  AccessGroupGeneralInfoEdit,
  RolesAccessLayout,
  RolesAccessList,
  RolesAccessAdd,
  AttachAction,
  RolesAccessGeneralInfoEdit,
  RolesAccessActionEdit,
  RolesAccessActionsAddActions,
  RolesAccessGeneralInfo,
  RolesAccessAction,
  RolesAccessUsers,
  ActionsLayout,
  ActionsList,
  ActionGeneralInfo,
  RolesLayout,
  RolesList,
  RoleAdd,
  RolesEdit,
  RolesGeneralInfo,
  UsersLayout,
  UserManagementList,
  UserAdd,
  UserEdit,
  UserInfo,
  UserAccountActions,
  UsersNumbers,
  UsersSMS,
  UserAccess,
  UsersPackages,
  UsersUsers,
  UserTariff,
  UserTariffEdit,
  Userpayments,
  UserTransactions,
  UserAccountRecharge,
  NumbersLayout,
  NumbersManegmentList,
  NumbersAdd,
  NumbersEdit,
  NumbersGeneralInfo,
  NumberTransactions,
  PackagesLayout,
  PackagesList,
  PackagesAdd,
  PackagesGeneralInfoEdit,
  PackagesAccessLevel,
  PackagesActiveUsers,
  PackagesGeneralInfo,
  PackagesNumbers,
  PackagesNumbersAdd,
  PackagesPayments,
  PackagesTrariff,
  PackagesTrariffAdd,
  PackagesTrariffEdit,
  OperatorsLayout,
  OperatorsList,
  OperatorsAdd,
  OperatorsEdit,
  OperatorsGeneralInfo,
  TransactionsLayout,
  TransactionsList,
  TransactionsGeneralInfo,
  TransactionsShares,
  TransactionsTransactionsHistory,
  TransactionsViewUser,
  PaymentsLayout,
  PaymentsList,
  PaymentsAdd,
  PaymentsGeneralInfo,
  PaymentsRelatedPayments,
  PaymentsTransaction,
  PaymentsViewUser,
  ChargesLayout,
  ChargesList,
  OrdersLayout,
  OrdersList,
  OrdersGeneralInfo,
  OrdersSendStatistics,
  OrdersReceivers,
  OrdersPayments,
  SMSLayout,
  SMSList,
  SMSGeneralInfo,
  SendReport,
  SMSSendLayout,
  SMSSendForm,
} from './routeList';
import { Pathes, toRoot } from '@/constants';
import PageLayout from '@/pages/Panel/PageLayout';

const authenticatedRouter = [
  {
    path: Pathes.ROOT,
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: Pathes.ACCESS_GROUPE,
        element: <AccessGroupLayout />,
        children: [
          {
            index: true,
            element: <Navigate to={Pathes.LIST} replace />,
          },
          {
            path: Pathes.LIST,
            element: <AccessGroupList />,
          },
          {
            path: Pathes.ADD,
            element: <AccessGroupAdd />,
          },
          {
            path: Pathes.ATTACH_ACCESS,
            element: <AccessGroupAttachAccess />,
          },
          {
            path: Pathes.EDIT,
            element: <AccessGroupGeneralInfoEdit />,
          },
          {
            path: 'edit/access/:id',
            element: <AccessGroupAccessEdit />,
          },
          {
            path: Pathes.DETAILS,
            element: <DetailLayout />,
            children: [
              {
                path: 'general-info',
                element: <AccessGroupGeneralInfo />,
              },
              { path: 'access', element: <AccessGroupAccess /> },
            ],
          },
        ],
      },
      {
        path: Pathes.ROLES_ACCESS,
        element: <RolesAccessLayout />,
        children: [
          {
            index: true,
            element: <Navigate to={Pathes.LIST} replace />,
          },
          {
            path: Pathes.LIST,
            element: <RolesAccessList />,
          },
          {
            path: Pathes.ADD,
            element: <RolesAccessAdd />,
          },
          {
            path: Pathes.ATTACH_ACTION,
            element: <AttachAction />,
          },
          {
            path: Pathes.EDIT,
            element: <RolesAccessGeneralInfoEdit />,
          },
          // {
          //   path: 'edit/actions/:id',
          //   element: <RolesAccessActionEdit />,
          // },
          {
            path: 'details/:id/add-action',
            element: <RolesAccessActionsAddActions />,
          },
          {
            path: Pathes.DETAILS,
            element: <DetailLayout />,
            children: [
              {
                path: 'general-info',
                element: <RolesAccessGeneralInfo />,
                // loader: () => {
                //   queryClient.fetchQuery({
                //     queryKey: ['pokemon'],
                //     queryFn: async () =>
                //       fetchClient('http://localhost:4000').then((res) => res.json()),
                //     staleTime: Infinity,
                //   });
                // },
              },
              { path: 'actions', element: <RolesAccessAction /> },
              { path: 'users', element: <RolesAccessUsers /> },
            ],
          },
        ],
      },
      {
        path: Pathes.ACTIONS,
        element: <ActionsLayout />,
        children: [
          {
            index: true,
            element: <Navigate to={Pathes.LIST} replace />,
          },
          {
            path: Pathes.LIST,
            element: <ActionsList />,
          },
          {
            path: Pathes.DETAILS,
            element: <DetailLayout />,
            children: [
              {
                path: 'general-info',
                element: <ActionGeneralInfo />,
              },
            ],
          },
        ],
      },
      {
        path: Pathes.ROLES_LABEL,
        element: <RolesLayout />,
        children: [
          {
            index: true,
            element: <Navigate to={Pathes.LIST} replace />,
          },
          {
            path: Pathes.LIST,
            element: <RolesList />,
          },
          {
            path: Pathes.ADD,
            element: <RoleAdd />,
          },
          {
            path: Pathes.EDIT,
            element: <RolesEdit />,
          },
          {
            path: Pathes.DETAILS,
            element: <DetailLayout />,
            children: [
              {
                path: 'general-info',
                element: <RolesGeneralInfo />,
              },
            ],
          },
        ],
      },
      {
        path: 'new-user',
        element: <UsersLayout />,
        children: [
          {
            index: true,
            element: <Navigate to='add' replace />,
          },
          {
            path: 'add',
            element: <UserAdd />,
          },
        ],
      },
      {
        path: Pathes.USERS,
        element: <UsersLayout />,
        children: [
          {
            index: true,
            element: <Navigate to={Pathes.LIST} replace />,
          },
          {
            path: Pathes.LIST,
            element: <UserManagementList />,
          },
          {
            path: Pathes.EDIT,
            element: <UserEdit />,
          },
          {
            path: '/users/details/payments/transactions/:id',
            element: <UserTransactions />,
          },
          {
            path: '/users/edit/tariff/:userId/:tariffId/:tariffType',
            element: <UserTariffEdit />,
          },
          {
            path: Pathes.DETAILS,
            element: <DetailLayout />,
            children: [
              {
                path: 'info',
                element: <UserInfo />,
              },
              {
                path: 'account-actions',
                element: <UserAccountActions />,
              },
              {
                path: 'numbers',
                element: <UsersNumbers />,
              },
              {
                path: 'sms',
                element: <UsersSMS />,
              },
              {
                path: 'access',
                element: <UserAccess />,
              },
              {
                path: 'packages',
                element: <UsersPackages />,
              },
              {
                path: 'sub-users',
                element: <UsersUsers />,
              },
              {
                path: 'tariff',
                element: <UserTariff />,
              },
              {
                path: 'payments',
                element: <Userpayments />,
              },
              {
                path: 'account-recharge',
                element: <UserAccountRecharge />,
              },
            ],
          },
        ],
      },
      {
        path: Pathes.NUMBERS,
        element: <NumbersLayout />,
        children: [
          {
            index: true,
            element: <Navigate to={Pathes.LIST} replace />,
          },
          {
            path: Pathes.LIST,
            element: <NumbersManegmentList />,
          },
          {
            path: Pathes.ADD,
            element: <NumbersAdd />,
          },
          {
            path: Pathes.EDIT,
            element: <NumbersEdit />,
          },
          {
            path: Pathes.DETAILS,
            element: <DetailLayout />,
            children: [
              {
                path: 'general-info',
                element: <NumbersGeneralInfo />,
              },
              {
                path: 'transactions',
                element: <NumberTransactions />,
              },
            ],
          },
        ],
      },
      {
        path: Pathes.PACKAGES,
        element: <PackagesLayout />,
        children: [
          {
            index: true,
            element: <Navigate to={Pathes.LIST} replace />,
          },
          {
            path: Pathes.LIST,
            element: <PackagesList />,
          },
          {
            path: Pathes.ADD,
            element: <PackagesAdd />,
          },
          {
            path: Pathes.EDIT,
            element: <PackagesGeneralInfoEdit />,
          },
          {
            path: 'details/tariff/add/:packageId',
            element: <PackagesTrariffAdd />,
          },
          {
            path: 'edit/tariff/:id',
            element: <PackagesTrariffEdit />,
          },
          { path: 'details/number/add/:id', element: <PackagesNumbersAdd /> },
          {
            path: Pathes.DETAILS,
            element: <DetailLayout />,
            children: [
              {
                path: 'general-info',
                element: <PackagesGeneralInfo />,
              },
              {
                path: 'access-level',
                element: <PackagesAccessLevel />,
              },
              {
                path: 'tariff',
                element: <PackagesTrariff />,
              },
              {
                path: 'number',
                element: <PackagesNumbers />,
              },
              {
                path: 'active-users',
                element: <PackagesActiveUsers />,
              },
              {
                path: 'payments',
                element: <PackagesPayments />,
              },
            ],
          },
        ],
      },
      {
        path: Pathes.OPERATORS,
        element: <OperatorsLayout />,
        children: [
          {
            index: true,
            element: <Navigate to={Pathes.LIST} replace />,
          },
          {
            path: Pathes.LIST,
            element: <OperatorsList />,
          },
          {
            path: Pathes.ADD,
            element: <OperatorsAdd />,
          },
          {
            path: Pathes.EDIT,
            element: <OperatorsEdit />,
          },
          {
            path: Pathes.DETAILS,
            element: <DetailLayout />,
            children: [
              {
                path: 'general-info',
                element: <OperatorsGeneralInfo />,
              },
            ],
          },
        ],
      },
      {
        path: Pathes.TRANSACTIONS,
        element: <TransactionsLayout />,
        children: [
          {
            index: true,
            element: <Navigate to={Pathes.LIST} replace />,
          },
          {
            path: Pathes.LIST,
            element: <TransactionsList />,
          },
          {
            path: Pathes.DETAILS,
            element: <DetailLayout />,
            children: [
              {
                path: 'general-info',
                element: <TransactionsGeneralInfo />,
              },
              {
                path: 'view-user',
                element: <TransactionsViewUser />,
              },
            ],
          },
        ],
      },
      {
        path: Pathes.PAYMENTS,
        element: <PaymentsLayout />,
        children: [
          {
            index: true,
            element: <Navigate to={Pathes.LIST} replace />,
          },
          {
            path: Pathes.LIST,
            element: <PaymentsList />,
          },
          {
            path: Pathes.ADD,
            element: <PaymentsAdd />,
          },
          {
            path: Pathes.DETAILS,
            element: <DetailLayout />,
            children: [
              {
                path: 'general-info',
                element: <PaymentsGeneralInfo />,
              },

              {
                path: 'transaction',
                element: <PaymentsTransaction />,
              },
              {
                path: 'view-user',
                element: <PaymentsViewUser />,
              },
            ],
          },
        ],
      },
      {
        path: Pathes.CHARGES,
        element: <ChargesLayout />,
        children: [
          {
            index: true,
            element: <Navigate to={Pathes.LIST} replace />,
          },
          {
            path: Pathes.LIST,
            element: <ChargesList />,
          },
        ],
      },
      {
        path: Pathes.ORDERS,
        element: <OrdersLayout />,
        children: [
          {
            index: true,
            element: <Navigate to={Pathes.LIST} replace />,
          },
          {
            path: Pathes.LIST,
            element: <OrdersList />,
          },
          {
            path: Pathes.DETAILS,
            element: <DetailLayout />,
            children: [
              {
                path: 'general-info',
                element: <OrdersGeneralInfo />,
              },
              {
                path: 'send-statistics',
                element: <OrdersSendStatistics />,
              },
              {
                path: 'receivers',
                element: <OrdersReceivers />,
              },
              {
                path: 'payment',
                element: <OrdersPayments />,
              },
            ],
          },
        ],
      },
      {
        path: Pathes.SMS,
        element: <SMSLayout />,
        children: [
          {
            index: true,
            element: <Navigate to={Pathes.LIST} replace />,
          },
          {
            path: Pathes.LIST,
            element: <SMSList />,
          },
          {
            path: Pathes.DETAILS,
            element: <DetailLayout />,
            children: [
              {
                path: 'general-info',
                element: <SMSGeneralInfo />,
              },
              {
                path: 'access',
                element: <>access</>,
              },
              {
                path: 'send-report',
                element: <SendReport />,
              },
            ],
          },
        ],
      },
      {
        path: Pathes.SEND_SMS,
        element: <SMSSendLayout />,
        children: [
          {
            index: true,
            element: <Navigate to={Pathes.FORM} replace />,
          },
          {
            path: Pathes.FORM,
            element: <SMSSendForm />,
          },
        ],
      },
    ],
  },
  ...toRoot.map((path) => ({
    path,
    element: <Navigate to={Pathes.ROOT} replace />,
  })),
  {
    path: '*',
    element: <NotFound />,
  },
];

export default authenticatedRouter;
